






































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IConvosOutputReplyVariableReplacements } from '@/api/types/response.types'
import { IStatusMapping } from '@/api/types/request.types'

/* API */

export default Vue.extend({
  name: 'ConfirmReplyVariablesModal',

  props: {
    createAnother: {
      type: Boolean,
      default: false,
    },
    hasCustomerName: {
      type: Boolean,
      default: false,
    },
    hasCustomerFirstName: {
      type: Boolean,
      default: false,
    },
    hasCustomerLastName: {
      type: Boolean,
      default: false,
    },
    variableReplacements: {
      type: Object as () => IConvosOutputReplyVariableReplacements,
      required: true,
    },
  },

  data() {
    return {
      ColorAssistant,
      isSubmitting: false,
      statusMappings: [] as IStatusMapping[],
    }
  },

  computed: {
    internalVariableReplacements: {
      get(): IConvosOutputReplyVariableReplacements {
        return this.variableReplacements
      },
      set(value: IConvosOutputReplyVariableReplacements) {
        this.$emit('update:variableReplacements', value)
      },
    },
    isSubmittable(): boolean {
      if (this.hasCustomerName) {
        if (
          this.internalVariableReplacements.customerName === null ||
          this.internalVariableReplacements.customerName.trim().length === 0
        ) {
          return false
        }
      }

      if (this.hasCustomerFirstName) {
        if (
          this.internalVariableReplacements.customerFirstName === null ||
          this.internalVariableReplacements.customerFirstName.trim().length ===
            0
        ) {
          return false
        }
      }

      if (this.hasCustomerLastName) {
        if (
          this.internalVariableReplacements.customerLastName === null ||
          this.internalVariableReplacements.customerLastName.trim().length === 0
        ) {
          return false
        }
      }

      return true
    },
  },

  methods: {
    closeModal() {
      this.$emit('confirm-canceled')
    },
    submit() {
      this.$emit('send-clicked')
    },
  },
})
